import VisuallyHidden from './VisuallyHidden';

export type { VisuallyHiddenProps } from './VisuallyHidden';
export default VisuallyHidden;
